import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios"; // You'll need axios for making API calls

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
    if (!email || !password) {
      alert("Please enter both email and password.");
      return;
    }

    try {
      // Make a request to your backend to check the user existence
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/public/delete-account`,
        {
          email,
          password,
        }
      );

      if (response.data.success) {
        alert(
          "Your account deletion request has been sent. The delete will happen within the next 3 days."
        );
        // You can navigate away or reset the form here if needed
      } else {
        alert(response.data.message); // Display the message from your backend
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 404) {
        alert("User not found");
      } else if (error.response.status === 401) {
        alert("Invalid Password.");
      } else {
        alert(
          "An error occurred while trying to delete your account. Please try again."
        );
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <>
          <h2 style={styles.title}>Account Deletion Request</h2>
          <div style={styles.inputContainer}>
            <label htmlFor="email" style={styles.label}>
              Email
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={handleEmailChange}
              style={styles.input}
            />
          </div>
          <div style={styles.inputContainer}>
            <label htmlFor="password" style={styles.label}>
              Password
            </label>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              value={password}
              onChange={handlePasswordChange}
              style={styles.input}
            />
            <span onClick={togglePasswordVisibility} style={styles.eyeIcon}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <button style={{ ...styles.button }} onClick={handleSubmit}>
            Submit
          </button>
        </>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
    padding: "16px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    marginBottom: "24px",
    fontSize: "24px",
    color: "#333",
    fontFamily: "Arial, sans-serif",
  },
  inputContainer: {
    position: "relative",
    marginBottom: "40px",
  },
  label: {
    position: "absolute",
    top: "50%",
    left: "16px",
    transform: "translateY(-50%)",
    color: "#333",
    fontSize: "16px",
    pointerEvents: "none",
    fontFamily: "Arial, sans-serif",
  },
  input: {
    padding: "12px 20px 12px 100px",
    fontSize: "16px",
    width: "100%",
    borderRadius: "20px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "black",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    alignSelf: "center",
  },
  eyeIcon: {
    position: "absolute",
    top: "50%",
    right: "16px",
    transform: "translateY(-50%)",
    cursor: "pointer",
    fontSize: "20px",
    color: "#666",
  },
};

export default DeleteAccount;
